import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';

export type GoalTypeCode =
  | 'weight_loss' | 'weight_gain' | 'health_support'
  | 'wellbeing_improvement' | 'muscle_building' | 'endurance';

export type GoalKind = 'quantitative' | 'qualitative';

/** Дзеркалить UserGoalResponseDto з api/src/modules/goals/dto/user-goal-response.dto.ts
 *  (GET /client/:clientId/main-goal - client.controller.ts). */
export interface ClientMainGoal {
  id: number;
  typeCode: GoalTypeCode;
  kind: GoalKind;
  desiredResult: string | null;
  startValue: number | null;
  currentValue: number | null;
  targetValue: number | null;
  unit: string | null;
  targetDate: string | null;
}

/** Головна ціль клієнта для дашборду експерта (ClientMainGoalCard) - null, якщо клієнт ще не
 *  створив жодної цілі. */
export const getClientMainGoal = async (clientId: number | string): Promise<ClientMainGoal | null> => {
  const response = await api.get<ApiResponse<ClientMainGoal | null>>(`/client/${clientId}/main-goal`);
  return unwrapApiResponse<ClientMainGoal | null>(response);
};
